<template>
    <form @submit.prevent="saveAnswers">
        <div class="mt-3">
            <h3 class="card-title">{{ $t('pages.subscription.start.questions.title') }}</h3>
            <p class="card-text" v-html="$t('pages.subscription.start.questions.safety_text')"></p>

            <hr>

<!--            <div class="mb-4">-->
<!--                <h5 class="font-weight-lighter">{{ $t('pages.subscription.start.questions.goal.my_goal') }}</h5>-->

<!--                <div class="form-check-inline">-->
<!--                    <label class="form-check-label">-->
<!--                        <input type="radio" class="form-check-input" v-model="goal" value="health">-->
<!--                        {{ $t('pages.subscription.start.questions.goal.goal_health') }}-->
<!--                        <i class="input-helper"></i>-->
<!--                    </label>-->
<!--                </div>-->
<!--                <div class="form-check-inline">-->
<!--                    <label class="form-check-label">-->
<!--                        <input type="radio" class="form-check-input" v-model="goal" value="fitness">-->
<!--                        {{ $t('pages.subscription.start.questions.goal.goal_fitness') }}-->
<!--                        <i class="input-helper"></i>-->
<!--                    </label>-->
<!--                </div>-->
<!--                <div class="form-check-inline">-->
<!--                    <label class="form-check-label">-->
<!--                        <input type="radio" class="form-check-input" v-model="goal" value="performance">-->
<!--                        {{ $t('pages.subscription.start.questions.goal.goal_performance') }}-->
<!--                        <i class="input-helper"></i>-->
<!--                    </label>-->
<!--                </div>-->
<!--                <div class="form-check-inline">-->
<!--                    <label class="form-check-label">-->
<!--                        <input type="radio" class="form-check-input" v-model="goal" value="other">-->
<!--                        {{ $t('pages.subscription.start.questions.goal.goal_other') }}-->
<!--                        <i class="input-helper"></i>-->
<!--                    </label>-->
<!--                </div>-->
<!--            </div>-->

<!--            <hr>-->
        </div>

        <div v-for="(question, i) in questions" :key="i" class="mt-4">
            <h5 class="font-weight-lighter">
                {{ question.text }}
            </h5>

            <div class="form-check-inline">
                <label class="form-check-label">
                    <input type="radio" class="form-check-input" v-model="question.answer" :value="true">
                    {{ $t('pages.subscription.start.questions.answer_yes') }}
                    <i class="input-helper"></i>
                </label>
            </div>

            <div class="form-check-inline">
                <label class="form-check-label">
                    <input type="radio" class="form-check-input" v-model="question.answer" :value="false">
                    {{ $t('pages.subscription.start.questions.answer_no') }}
                    <i class="input-helper"></i>
                </label>
            </div>
            <hr>

        </div>

        <div class="alert alert-secondary border-dark shadow-sm mt-5 mb-4">
            <p class="card-text" v-html="$t('pages.subscription.start.questions.safety_bottom_text')"></p>
        </div>


        <span class="text-danger mb-3" v-if="!hasAnsweredAllQuestions">
            {{ $t('pages.subscription.start.questions.please_answer_all') }}
        </span>
        <div class="form-group mt-2">
            <button class="btn btn-outline-dark" :disabled="!hasAnsweredAllQuestions" :class="{'btn-disabled': !hasAnsweredAllQuestions}">
                {{ $t('pages.subscription.start.address.continue') }}
            </button>
        </div>

    </form>
</template>

<script>
import CountryRepository from "../../../repositories/Countries/CountryRepository";
import AddressForm from "./Includes/AddressForm";
import SubscriptionStartRepository from "../../../repositories/Subscription/SubscriptionStartRepository";

export default {
    name: "SubscriptionStartQuestions",
    data: () => ({
        goal: null,
        questions: [
            { answer: null,     text: '' },
            { answer: null,     text: '' },
            { answer: null,     text: '' },
            { answer: null,     text: '' },
            { answer: null,     text: '' },
            { answer: null,     text: '' },
            { answer: null,     text: '' },
        ]
    }),
    mounted() {
        this.questions[0].text = this.$t('pages.subscription.start.questions.question_one');
        this.questions[1].text = this.$t('pages.subscription.start.questions.question_two');
        this.questions[2].text = this.$t('pages.subscription.start.questions.question_three');
        this.questions[3].text = this.$t('pages.subscription.start.questions.question_four');
        this.questions[4].text = this.$t('pages.subscription.start.questions.question_five');
        this.questions[5].text = this.$t('pages.subscription.start.questions.question_six');
        this.questions[6].text = this.$t('pages.subscription.start.questions.question_seven');

        window.scrollTo(0,0);
    },
    computed: {
        hasAnsweredAllQuestions() {
          return this.questions.every(q => q.answer !== null);
        }
    },
    methods: {
        saveAnswers() {
            if(!this.hasAnsweredAllQuestions) {
                this.$snotify.error(this.$t('pages.subscription.start.questions.please_answer_all'));
                return false;
            }

            SubscriptionStartRepository.answerQuestions({
                questions: this.questions,
                goal: this.goal
            }).then((res) => this.$emit('step-completed'));
        }
    },
}
</script>

<style scoped>

</style>
